import { DashboardTile } from "../components/DashboardTile";
import { TileHeader } from "../components/TileHeader";
import { useMemo } from "react";
import { OfferCategory, useOffersQuery } from "@common/utils/graphql";
import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";
import { Body } from "@hypercard/web-components";
import { AirplaneTilt, Barbell, Car, ForkKnife } from "@phosphor-icons/react";
import { IconBox } from "@common/components";
import { twMerge } from "@/utils/utils";

type Props = {
  className?: string;
};

export const FeaturedPerksTile = ({ className }: Props) => {
  const {
    loading: featuredPerksLoading,
    data: featuredPerksData,
    error,
  } = useOffersQuery({
    variables: {
      categories: [OfferCategory.Lifestyle],
    },
  });

  const featuredPerks = useMemo(() => {
    if (featuredPerksData?.offers?.__typename !== "QueryOffersSuccess") {
      return [];
    }
    return featuredPerksData?.offers?.data.offers.slice(0, 4);
  }, [featuredPerksData]);

  const emptyTile = (
    <div className="flex h-[290px] flex-col items-center justify-center pb-8">
      <div className="flex gap-3">
        <IconBox>
          <ForkKnife className="size-8" />
        </IconBox>
        <IconBox>
          <Barbell className="size-8" />
        </IconBox>
        <IconBox>
          <AirplaneTilt className="size-8" />
        </IconBox>
        <IconBox>
          <Car className="size-8" />
        </IconBox>
      </div>
      <Body size="lg" weight="medium" className="mt-6">
        Exclusive Perks Await
      </Body>
      <Body
        size="sm"
        weight="regular"
        className="mt-2 whitespace-pre text-center text-white/70"
      >
        {"Our best perks are just around the corner."}
      </Body>
    </div>
  );
  return (
    <DashboardTile className={twMerge("flex flex-col", className)}>
      <TileHeader>FEATURED PERKS</TileHeader>
      {error ? (
        emptyTile
      ) : featuredPerksLoading ? (
        <div className="grid grid-cols-2 gap-3">
          <Skeleton className="h-[290px] w-[340px] rounded-xl" />
        </div>
      ) : featuredPerks.length > 0 ? (
        <div className="grid grid-cols-2 gap-3">
          {featuredPerks.map((perk, idx) => (
            <Card
              className="h-full w-full bg-white/10 p-4"
              key={`${perk.title}-${idx}`}
            >
              <img
                src={perk.iconImageUrl || perk.hypercardMerchant?.logoImageUrl}
                className="mb-2 h-8 w-8 rounded"
              />
              <Body size="sm" weight="medium">
                {perk.title}
              </Body>
              <Body
                size="xs"
                weight="regular"
                className="mt-1 line-clamp-3 text-white/50"
              >
                {perk.details}
              </Body>
            </Card>
          ))}
        </div>
      ) : (
        emptyTile
      )}
    </DashboardTile>
  );
};
